import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportComponent } from './page/report/report.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { LoginComponent } from './page/login/login.component';
import { HeaderComponent } from './shared/header/header.component';
import { LayoutComponent } from './shared/layout/layout.component';
import { AuthGuard } from './core/guard/auth.guard';
import { FormSuccessComponent } from './page/form-success/form-success.component';

export const routes: Routes = [
  { 
    path: '' ,
    redirectTo: 'login', 
    pathMatch: 'full' 
  },
 
  {
    path:'login',
    component:LoginComponent
  },
  {
    path:'report',
    component:LayoutComponent,
    canActivate:[AuthGuard],
    children:[
      {
        path:'',
        component:ReportComponent,
      }
    ]
  },
  {
    path:'success',
    component:LayoutComponent,
    canActivate:[AuthGuard],
    children:[
      {
        path:'',
        component:FormSuccessComponent,
      }
    ]
  },
  {
    path:'**',
    redirectTo:'login'
  }
];

@NgModule({
    // imports: [RouterModule.forRoot(routes)],
   
    imports: [
      RouterModule.forRoot(routes)
    ],
    exports: [RouterModule]
  })
  export class AppRoutingModule { }